module.exports = __webpack_public_path__ + "img/exercise_test-1.97ed0461.gif";